module.exports = __webpack_public_path__ + "static/media/emojis_25.994d75c8.svg";